import { ALL } from "@/constants";

export const ALL_FILTER_OPTION = { text: ALL, value: null } as const;

export const createAllSelection = (): string[] => [ALL];

export const prependAllSelection = (values: string[]): string[] => [ALL, ...values];

export const hasAllValue = (values: unknown): boolean => Array.isArray(values) && values.some((value) => value === ALL);

export const isUnsetOrAllSelection = (values: unknown): boolean =>
  !Array.isArray(values) || values.length === 0 || (values.length === 1 && values[0] === ALL);

export const withAllSelectionFallback = (values: string[]): string[] => (values.length ? values : createAllSelection());
